import React from "react";
import {
  Box,
  Checkbox,
  FormControlLabel,
  TextField,
  Typography,
} from "@mui/material";
import { COLORS, FONT } from "../../constants";
import DEED_CLAUSES from "./deedText";
import SignaturePad from "./SignaturePad";
import SuretyRow from "./SuretyRow";

const DeedOfSuretyshipStep = ({
  sureties,
  onSuretyNameChange,
  onSuretyIdChange,
  onSuretySave,
  onSuretyClear,
  regNo,
  setRegNo,
  agreedDeed,
  setAgreedDeed,
  sigSaved,
  setSigSaved,
  isMobile,
}) => {
  return (
    <Box sx={{ display: "flex", flexDirection: "column", flex: 1 }}>
      <Typography
        sx={{
          fontSize: FONT.size.xs,
          fontWeight: 600,
          color: COLORS.darkText,
          letterSpacing: 0.5,
          mb: 1.5,
          textTransform: "uppercase",
        }}
      >
        C. DEED OF SURETYSHIP
      </Typography>

      <Typography
        sx={{
          fontSize: isMobile ? FONT.size.xs : FONT.size.sm,
          color: COLORS.darkText,
          mb: 2,
        }}
      >
        I, the undersigned,
      </Typography>

      <Box sx={{ display: "flex", flexDirection: "column", gap: 2, mb: 2 }}>
        {sureties.map((s, i) => (
          <SuretyRow
            key={i}
            index={i + 1}
            required={i === 0}
            name={s.name}
            idNo={s.idNo}
            sig={s.sig}
            onNameChange={(val) => onSuretyNameChange(i, val)}
            onIdChange={(val) => onSuretyIdChange(i, val)}
            onSave={(dataUrl) => onSuretySave(i, dataUrl)}
            onClear={() => onSuretyClear(i)}
          />
        ))}
      </Box>

      <Typography
        sx={{
          fontSize: isMobile ? FONT.size.xs : FONT.size.sm,
          color: COLORS.darkText,
          lineHeight: 1.8,
          mb: 2,
          textAlign: "justify",
        }}
      >
        do hereby bind myself jointly and severally in favour of:{" "}
        <Box component="span" sx={{ fontWeight: 700 }}>
          ARGUS MOTORS C.C.
        </Box>{" "}
        (hereinafter called &ldquo;the Creditor&rdquo;) as surety for and
        co-principal debtor in solidum with:
      </Typography>

      <Box sx={{ display: "flex", alignItems: "center", gap: 2, mb: 3 }}>
        <Typography
          sx={{
            fontSize: isMobile ? FONT.size.xs : FONT.size.sm,
            fontWeight: 700,
            color: COLORS.darkText,
            whiteSpace: "nowrap",
          }}
        >
          REG. NO.:
          <Box component="span" sx={{ color: COLORS.themeRed, ml: 0.25 }}>
            *
          </Box>
        </Typography>
        <TextField
          size="small"
          value={regNo}
          onChange={(e) => setRegNo(e.target.value)}
          placeholder="Company registration number"
          sx={{
            flex: 1,
            "& .MuiOutlinedInput-root": {
              borderRadius: "2px",
              "& fieldset": {
                borderColor: regNo.trim() ? COLORS.themeRed : "#d0d0d0",
              },
              "&:hover fieldset": { borderColor: COLORS.themeBlack },
              "&.Mui-focused fieldset": {
                borderColor: COLORS.themeBlack,
                borderWidth: 1,
              },
            },
            "& .MuiInputBase-input": { fontSize: FONT.size.sm },
          }}
        />
      </Box>

      <Box
        sx={{
          overflowY: "auto",
          border: "1px solid #e0e0e0",
          borderRadius: "4px",
          p: 2.5,
          backgroundColor: "#fafafa",
          maxHeight: 600,
          mb: 2,
        }}
      >
        {DEED_CLAUSES.map((clause) => (
          <Typography
            key={clause.id}
            sx={{
              fontSize: FONT.size.xs,
              color: COLORS.darkText,
              lineHeight: 1.85,
              mb: 1.5,
              pl: clause.subIndent ? 4 : clause.indent ? 2 : 0,
              textAlign: "justify",
            }}
          >
            {(() => {
              const space = clause.text.indexOf(" ");
              const num = clause.text.slice(0, space);
              const body = clause.text.slice(space);
              return (
                <>
                  <Box component="span" sx={{ fontWeight: 700 }}>
                    {num}
                  </Box>
                  {body}
                </>
              );
            })()}
          </Typography>
        ))}
      </Box>

      <FormControlLabel
        sx={{ mb: 1, alignItems: "flex-start" }}
        control={
          <Checkbox
            checked={agreedDeed}
            onChange={(e) => setAgreedDeed(e.target.checked)}
            size="small"
            sx={{
              pt: 0,
              color: "#cccccc",
              "&.Mui-checked": { color: COLORS.themeRed },
            }}
          />
        }
        label={
          <Typography
            sx={{ fontSize: FONT.size.xs, color: COLORS.darkText, lineHeight: 1.6 }}
          >
            I have read and understood the Deed of Suretyship above and agree to
            be bound by its terms and conditions.
          </Typography>
        }
      />

      <SignaturePad
        saved={sigSaved}
        onSave={(dataUrl) => setSigSaved(dataUrl)}
        onClear={() => setSigSaved(null)}
      />
    </Box>
  );
};

export default DeedOfSuretyshipStep;
